import React from 'react';

const About = () => {
    return (
        <section id="nosotros" className="py-24 bg-dark text-white relative overflow-hidden">
            {/* Decoration */}
            <div className="absolute top-0 right-0 -mt-20 -mr-20 w-80 h-80 bg-brand-600 rounded-full blur-3xl opacity-20"></div>
            <div className="absolute bottom-0 left-0 -mb-20 -ml-20 w-80 h-80 bg-brand-600 rounded-full blur-3xl opacity-20"></div>

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                <div className="grid lg:grid-cols-2 gap-16 items-center">
                    <div>
                        <h2 className="text-brand-500 font-semibold tracking-wide uppercase text-sm mb-2">Por Qué Elegirnos</h2>
                        <h3 className="text-3xl md:text-4xl font-bold mb-6">No somos solo un software, somos el corazón operativo de tu taller.</h3>
                        <p className="text-gray-400 mb-8 text-lg leading-relaxed">
                            Sabemos que en un taller el tiempo es dinero y cada repuesto que no se cobra es una pérdida directa. Garaje Pro 360 elimina el caos, el "robo hormiga" y los errores de cobro con una plataforma pensada desde adentro del taller.
                        </p>

                        <ul className="space-y-6">
                            <li className="flex items-start">
                                <div className="flex-shrink-0 w-12 h-12 bg-white/10 rounded-full flex items-center justify-center mt-1 border border-white/5">
                                    <i data-lucide="shield-check" className="text-brand-400 w-6 h-6"></i>
                                </div>
                                <div className="ml-4">
                                    <h5 className="text-xl font-bold mb-1">Cero Pérdidas de Inventario</h5>
                                    <p className="text-gray-400">Cada repuesto que sale del estante queda registrado y cobrado automáticamente. Se acabó el "robo hormiga" y los repuestos que se usan pero no aparecen en la factura.</p>
                                </div>
                            </li>
                            <li className="flex items-start">
                                <div className="flex-shrink-0 w-12 h-12 bg-white/10 rounded-full flex items-center justify-center mt-1 border border-white/5">
                                    <i data-lucide="trending-up" className="text-brand-400 w-6 h-6"></i>
                                </div>
                                <div className="ml-4">
                                    <h5 className="text-xl font-bold mb-1">Flujo de Caja Optimizado</h5>
                                    <p className="text-gray-400">El dueño sabe exactamente cuánto dinero tiene detenido en estanterías y qué productos no se están moviendo. Compras inteligentes, no compras por intuición.</p>
                                </div>
                            </li>
                            <li className="flex items-start">
                                <div className="flex-shrink-0 w-12 h-12 bg-white/10 rounded-full flex items-center justify-center mt-1 border border-white/5">
                                    <i data-lucide="calendar" className="text-brand-400 w-6 h-6"></i>
                                </div>
                                <div className="ml-4">
                                    <h5 className="text-xl font-bold mb-1">Orden Total en la Agenda</h5>
                                    <p className="text-gray-400">Se acaba el caos de 5 carros llegando a la misma hora sin mecánicos libres. Cada cita tiene su slot de tiempo, su mecánico asignado y su recordatorio automático al cliente.</p>
                                </div>
                            </li>
                            <li className="flex items-start">
                                <div className="flex-shrink-0 w-12 h-12 bg-white/10 rounded-full flex items-center justify-center mt-1 border border-white/5">
                                    <i data-lucide="eye" className="text-brand-400 w-6 h-6"></i>
                                </div>
                                <div className="ml-4">
                                    <h5 className="text-xl font-bold mb-1">Cliente Informado, Taller Tranquilo</h5>
                                    <p className="text-gray-400">El cliente ve en tiempo real el avance de su vehículo, deja notas al agendar y recibe las observaciones del mecánico al cerrar la orden. Se eliminan las llamadas, la incertidumbre y los malentendidos.</p>
                                </div>
                            </li>
                        </ul>
                    </div>

                    <div className="relative">
                        <div className="aspect-[4/5] rounded-3xl overflow-hidden shadow-2xl">
                            <img src="https://images.unsplash.com/photo-1517524008697-84bbe3c3fd98?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Taller gestionado con Garaje Pro 360" className="w-full h-full object-cover" />
                        </div>
                        {/* Floating badge */}
                        <div className="absolute -bottom-8 -left-8 bg-brand-600 text-white p-6 rounded-2xl shadow-xl max-w-xs hidden sm:block">
                            <div className="flex items-center gap-4 mb-2">
                                <i data-lucide="zap" className="fill-current text-yellow-300 w-6 h-6"></i>
                                <span className="text-2xl font-bold">Tu propia Landing</span>
                            </div>
                            <p className="text-sm text-brand-100">Cada taller registrado recibe su página web automática con su slug, colores y datos. Presencia digital desde el día uno.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;
